import React, { useEffect } from "react";
import { X, ExternalLink, Clock } from "lucide-react";

const VideoModal = ({ video, onClose }) => {
  useEffect(() => {
    if (!video) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [video, onClose]);

  if (!video) return null;

  const vimeoUrl = `https://vimeo.com/${video.vimeoId}`;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm"
      onClick={onClose}
    >
      <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            <h3 className="font-display text-white text-xl md:text-2xl">{video.title}</h3>
            {video.badge && (
              <span
                className="font-display text-xs px-3 py-1 rounded-full text-white"
                style={{ backgroundColor: "#FF6C10" }}
              >
                {video.badge}
              </span>
            )}
          </div>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-10 h-10 rounded-full bg-white/15 hover:bg-white/25 text-white transition-colors shrink-0"
            aria-label="Close video"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {video.comingSoon || !video.vimeoId ? (
          <div className="rounded-2xl shadow-2xl bg-white aspect-video flex flex-col items-center justify-center text-center px-6">
            <span
              className="flex items-center justify-center w-16 h-16 rounded-full mb-4"
              style={{ backgroundColor: "rgba(255,108,16,0.15)" }}
            >
              <Clock className="w-8 h-8" style={{ color: "#FF6C10" }} />
            </span>
            <p className="font-display text-2xl md:text-3xl" style={{ color: "#187EE4" }}>
              Coming Soon!
            </p>
            <p className="mt-3 text-slate-600 font-medium max-w-md">
              The &ldquo;{video.title}&rdquo; video is on its way. Check back soon to
              help your little one turn knowledge into courage.
            </p>
          </div>
        ) : (
          <>
            <div className="rounded-2xl overflow-hidden shadow-2xl bg-black aspect-video">
              <iframe
                className="w-full h-full"
                src={`https://player.vimeo.com/video/${video.vimeoId}?autoplay=1&title=0&byline=0&portrait=0`}
                title={video.title}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="mt-3 flex items-center justify-center">
              <a
                href={vimeoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm font-semibold transition-colors"
              >
                Trouble playing? Watch on Vimeo <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VideoModal;
